import { CarvanaHeaderPlugin } from '@carvana/header';
import { MicroFEComponent } from '@carvana/microfrontend';
import React from 'react';
import { Wrapper } from './Header.styles';

const CarvanaHeader = () => <CarvanaHeaderPlugin shouldLoadPlugin={false} />;

const Header = () => (
  <Wrapper>
    <MicroFEComponent
      id="default"
      module="HeaderModule"
      fallback={CarvanaHeader}
    >
      {({ Component: HeaderComponent }) => (
        <HeaderComponent
          environment={process.env.CARVANA_APP_ENVIRONMENT}
          // headerContext={headerContext}
          headerContext={{}}
          profile={{ partner: { partnerId: 1 } }} />
      )}
    </MicroFEComponent>
  </Wrapper>
);

export default Header;
